<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon small link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
					<span class="navigation-title">{{$t('documents')}}</span>
					<div class="navigation-right">
						<router-link :to="{name: 'create-document'}"><svg class="navigation-icon link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg></router-link>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top no-padding-bottom">
				<FilteredSearch :loaded="documentsLoaded" :list="documents" :click="documentClick" :customText="documentText" :placeholder="$t('search')" :deleteAction="deleteAction" :filterAttributes="filterAttributes"/>
			</section>
		</transition>
	</div>
</template>

<script>
import FilteredSearch from '@/components/FilteredSearch.vue'

export default {
	data() {
		return {
			documents: [],
			documentsLoaded: false,
			filterAttributes: [
				{attribute: 'name', text: this.$t('name')},
				{attribute: 'filename', text: this.$t('filename')},
			],
		};
	},
	created() {
		let self = this;
		axios.get(`/documents`)
		.then((response) => {
			self.documents = [...response.data.response.documents];
			self.documentsLoaded = true;
		})
		.catch(err => {
			console.log(err);
		});
	},
	watch: {
	},
	methods: {
		documentClick(item) {
			this.$router.push({name: 'document', params: {id: item.id}});
		},
		documentText(item) {
			return `${item.name}`
		},
		deleteAction(selected) {
			return new Promise((resolve, reject) => {
				let self = this;
				let ids = selected.map(o => o.id);

				let onConfirm = (buttonIndex) => {
					if (buttonIndex == 1) {
						Promise.all(ids.map(id => {
							return new Promise((resolve, reject) => {
								axios.delete(`/documents/${id}`)
								.then((response) => {
									self.documents = self.documents.filter(o => o.id != id);
									resolve();
								})
								.catch((err) => {
									let resp = err.response;
									reject(resp);
								});
							});
						}))
						.then(() => {
							self.$snack.success(self.$tc('document-deleted-successfully', ids.length));
							return resolve();
						})
						.catch((err) => {
							self.$snack.danger(self.$t('delete-error'));

							if (navigator.vibrate){
								navigator.vibrate([500]);
							}
							return reject();
						});
					}
				}
				let message = self.$tc('delete-document-confirm', ids.length, {count: ids.length});
				if (navigator.notification) {
					navigator.notification.confirm(
						message,	// message
						onConfirm,						// callback to invoke with index of button pressed
						this.$t('delete-yarn'),			// title
						[this.$t('confirm'),
						this.$t('cancel')]	// buttonLabels
					);
				} else {
					if (confirm(message)) onConfirm(1);
				}
			});
		},
	},
	components: {
		FilteredSearch
	},
}
</script>

<style scoped>
</style>